import { ApiResult } from 'src/Libs/api'
import { FeedInPowerModel } from '../model'
import { AuthFetchWithResponse } from 'src/Types/api'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { UnexpectedApiResponseError } from 'src/Libs/errors'
import { FeedInPowerDto } from './dto'
import { fromFeedInPowerDtoToModelTransformer, fromFeedInPowerModelToDtoTransformer } from '../transformers'

/**
 * Get data for feed-in power.
 *
 * @param storageId
 * @param authFetch
 * @returns
 */
export const fetchFeedInPower = async (
  storageId: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<FeedInPowerModel, AuthFetchError | Error>> => {
  try {
    const response = await authFetch<FeedInPowerDto>({
      path: `storages/${storageId}/feed-in-power`,
      method: 'GET',
      endpoint: process.env.REACT_APP_API_ENDPOINT,
    })
    if (response.status === StatusCodes.OK) {
      const feedInPowerModel = fromFeedInPowerDtoToModelTransformer(response.data)
      return new ApiResult<FeedInPowerModel, AuthFetchError | Error>(feedInPowerModel, false)
    }
    return new ApiResult<FeedInPowerModel, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<FeedInPowerModel>(error)
  }
}

/**
 * Set the settings values for feed-in power.
 *
 * @param storageId
 * @param values
 * @param authFetch
 */
export const updateFeedInPower = async (storageId: string | undefined, values: FeedInPowerModel, authFetch: AuthFetchWithResponse): Promise<void> => {
  const payload = fromFeedInPowerModelToDtoTransformer(values)

  const response = await authFetch<void>({
    path: `storages/${storageId}/feed-in-power`,
    method: 'PUT',
    endpoint: process.env.REACT_APP_API_ENDPOINT,
    payload,
  })
  if (response.status !== StatusCodes.NO_CONTENT) {
    throw new UnexpectedApiResponseError(response.status)
  }
}
